import React, { useState } from "react";
import "../../style/Droppable.css";

function Droppable() {
  const [activeTab, setActiveTab] = useState("simple");
  const [dropped, setDropped] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDropped(true);
  };

  const allowDrop = (e) => {
    e.preventDefault();
  };

  const handleDragStart = (e) => {
    e.dataTransfer.setData("text", "drag-item");
  };

  return (
    <div className="droppable-container col-md-8 col-lg-8 col-xl-8">

      <h1 className="mb-3 fw-normal border-bottom text-left pb-2 mb-4">
        Droppable
      </h1>

      {/* Tabs */}

      <div className="nav nav-tabs">

        <button
          className={`nav-link ${activeTab === "simple" ? "active" : ""}`}
          onClick={() => setActiveTab("simple")}
        >
          Simple
        </button>

        <button
          className={`nav-link ${activeTab === "accept" ? "active" : ""}`}
          onClick={() => setActiveTab("accept")}
        >
          Accept
        </button>

        <button
          className={`nav-link ${activeTab === "prevent" ? "active" : ""}`}
          onClick={() => setActiveTab("prevent")}
        >
          Prevent Propagation
        </button>

        <button
          className={`nav-link ${activeTab === "revert" ? "active" : ""}`}
          onClick={() => setActiveTab("revert")}
        >
          Revert Droppable
        </button>

      </div>

      {/* SIMPLE TAB */}

      {activeTab === "simple" && (
        <div className="drop-area">

          <div
            className="draggable-box"
            draggable
            onDragStart={handleDragStart}
          >
            Drag me to my target
          </div>

          <div
            className={`droppable-box ${dropped ? "dropped" : ""}`}
            onDrop={handleDrop}
            onDragOver={allowDrop}
          >
            {dropped ? "Dropped!" : "Drop here"}
          </div>

        </div>
      )}

      {/* ACCEPT TAB */}

      {activeTab === "accept" && (
        <div className="drop-area">

          <div
            className="droppable-box"
            onDrop={handleDrop}
            onDragOver={allowDrop}
          >
            Drop here
          </div>

          <div
            className="draggable-box"
            draggable
            onDragStart={handleDragStart}
          >
            Drag me
          </div>

        </div>
      )}

      {/* EMPTY TABS */}

      {activeTab === "prevent" && (
        <div className="tab-info">Prevent propagation example</div>
      )}

      {activeTab === "revert" && (
        <div className="tab-info">Revert droppable example</div>
      )}

    </div>
  );
}

export default Droppable;